import React, { useState, useEffect } from "react";
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from "@mui/material";

import ApexChart from "react-apexcharts";
import CloseIcon from "@mui/icons-material/Close";



const MarketSharePopup = ({ open, title, apiData, setOpen }) => {
  const handleClose = () => setOpen(false);

  

  const [chartState, setChartState] = useState({
    series: [
      {
        name: "Market Share",
        type: "line",
        data: [],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: 'line',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false
        }
      },
      markers: {
        size: 4
      },
      colors: ["#F59D1E"],
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      labels: [
      ],
    },
  });


  useEffect(() => {
    const marketShare = []
    const labels = []
    apiData.forEach((data, index) => {
      marketShare.push(data.market_share)
      labels.push(data.quarter)
  });

    setChartState((chartState) => ({
      ...chartState,
      series: [
        {
          name: "Market Share",
          type: "line",
          data: marketShare,
        }
      ],
      options: {
        ...chartState.options,
        labels,
      }
    }))

  }, [apiData])

  return (
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography
            variant="h6"
            sx={{ color: "#d32f2f", fontWeight: "bold" }}
          >
            {title}<span style={{ fontWeight: "400" }}>(Market Share)</span>
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <ApexChart options={chartState.options} series={chartState.series} type="line"/>
        </DialogContent>
      </Dialog>
  );
};

export default MarketSharePopup;

